import React from "react";
import { videosFilter } from "../../utils/Dummy";

const AnimationFilters = ({ selectedFilter, setSelectedFilter }) => {
  return (
    <ul
      className="flex flex-wrap gap-3 cursor-pointer"
      data-aos="fade-left"
      data-aos-delay="800"
    >
      {videosFilter.map((filter, index) => (
        <li
          key={index}
          className={
            selectedFilter === filter.value
              ? "me-4 text-sky-500 font-semibold text-sm"
              : "me-4 text-gray-400 font-semibold text-sm"
          }
          onClick={() => setSelectedFilter(filter.value)}
        >
          {filter.name}
        </li>
      ))}
    </ul>
  );
};

export default AnimationFilters;
